import type { AccidentUserType } from '../../types/accident';
import type { SameAsValue } from '../AccidenCreatingStepCustomerInformations';

export interface UseParticipantToggleLogicProps {
  userType: AccidentUserType;
  operatorType: AccidentUserType;
  operatorSameAsOwner: boolean;
  driverSameAsOwner?: SameAsValue;
}

/**
 * Hook pro správu logiky zobrazení/skrytí možností u řidiče a kontaktní osoby
 * Řidič ani kontaktní osoba nemůžou být firma (pouze právnická osoba)
 */
export const useParticipantToggleLogic = ({
  userType,
  operatorType,
  operatorSameAsOwner,
  driverSameAsOwner
}: UseParticipantToggleLogicProps) => {
  // Kontrola, zda je uživatel/operátor firma (pouze Company, ne BusinessMan)
  const isUserCompanyOnly = userType === 'company';
  const isOperatorCompanyOnly = operatorType === 'company';

  // Kontrola, zda je uživatel/operátor firma nebo podnikatel (pro jiné účely)
  const isUserCompanyOrBusiness = userType === 'company' || userType === 'businessman';
  const isOperatorCompanyOrBusiness = operatorType === 'company' || operatorType === 'businessman';

  // Podmínky pro řidiče
  const shouldHideUserOptionForDriver = isUserCompanyOnly;
  // Skrýt možnost "operator", pokud je operátor stejný jako majitel NEBO pokud je operátor firma
  const shouldHideOperatorOptionForDriver = operatorSameAsOwner || isOperatorCompanyOnly;

  // Podmínky pro kontaktní osobu (stejné jako pro řidiče)
  const shouldHideUserOptionForContact = isUserCompanyOnly;
  // Skrýt možnost "operator", pokud je operátor stejný jako majitel NEBO pokud je operátor firma
  const shouldHideOperatorOptionForContact = operatorSameAsOwner || isOperatorCompanyOnly;
  // Skrýt možnost "driver", pokud je řidič firma (což by znamenalo, že je stejný jako majitel/operátor který je firma)
  const shouldHideDriverOptionForContact =
    (driverSameAsOwner === 'user' && isUserCompanyOnly) || (driverSameAsOwner === 'operator' && isOperatorCompanyOnly);

  return {
    shouldHideUserOptionForDriver,
    shouldHideOperatorOptionForDriver,
    shouldHideUserOptionForContact,
    shouldHideOperatorOptionForContact,
    shouldHideDriverOptionForContact,
    isUserCompanyOnly,
    isOperatorCompanyOnly,
    isUserCompanyOrBusiness,
    isOperatorCompanyOrBusiness
  };
};
